var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.active)?_c('div',{class:[
    _vm.positionClasses,
    _vm.sizeClasses,
    _vm.positionType,
    'z-61 inset-ring-1 inset-ring-neutral-400 shadow-around backface-hidden animate-loading-logo flex select-none items-center justify-center rounded-xl bg-white p-1 shadow-black/5',
  ]},[(_vm.catalogSettings?.logo)?_c('img',{staticClass:"max-h-full max-w-full rounded-lg object-contain",attrs:{"src":_vm.catalogSettings.logo}}):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }